import React, { useState, useEffect } from 'react';
import styles from './style.module.scss';
import BusinessInformation from './components/business-information';
import PersonalInformation from './components/personal-information';
import BusinessProfile from './components/business-profile';
import CreditCardProcessing from './components/credit-card-processing';
import Pricing from './components/pricing';
import Equipment from './components/equipment';
import Details from './components/details';
import Processor from './components/processor';
import SignAgreement from './components/sign-agreement';
import useCommonStore from '../../../../../../stores/common';
import useSalesFormStore from '../../../../../../stores/sales-form';

/**
 * ReviewSubmit Component
 * Renders a review page showing all sections of the application form
 * with the ability to toggle sections and edit individual parts
 * 
 * @param {Object} props - Component props
 * @param {Object} props.formik - Formik form instance containing values, errors, and handlers
 * @param {Function} props.onSectionChange - Callback function when a section edit button is clicked
 */
const ReviewSubmit = ({ formik, onSectionChange, pricingModel, pricingData, equipmentData, activeAppData, reRender }) => {
  const [openSections, setOpenSections] = useState({
    'business-information': true,
    'personal-information': false,
    'business-profile': false,
    'credit-card-processing': false,
    'pricing': false,
    'equipment': false,
    'processor': false,
    'details': false
  });

  const isAuthenticated = useSalesFormStore((state) => state.isAuthenticated);
  const otpVerificationTime = useSalesFormStore((state) => state.otpVerificationTime);
  
  /**
   * Toggles the visibility of a section
   * @param {string} section - Section identifier to toggle
   */
  const toggleSection = (section) => {
    setOpenSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  const setExpandDetails = useCommonStore((state) => state.setExpandDetails);

  useEffect(() => {
    setExpandDetails(true);
  }, []);

  return (
    <div className={styles.reviewSubmit}>
      <BusinessInformation
        formik={formik}
        onEdit={() => onSectionChange('business-information')}
        isOpen={openSections['business-information']}
        onToggle={() => toggleSection('business-information')}
      />
      <PersonalInformation
        formik={formik}
        onEdit={() => onSectionChange('personal-information')}
        isOpen={openSections['personal-information']}
        onToggle={() => toggleSection('personal-information')}
      />
      <BusinessProfile
        formik={formik}
        onEdit={() => onSectionChange('business-profile')}
        isOpen={openSections['business-profile']}
        onToggle={() => toggleSection('business-profile')}
      />
      <CreditCardProcessing
        formik={formik}
        onEdit={() => onSectionChange('credit-card-processing')}
        isOpen={openSections['credit-card-processing']}
        onToggle={() => toggleSection('credit-card-processing')}
      />
      <Pricing
        formik={formik}
        isOpen={openSections['pricing']}
        onToggle={() => toggleSection('pricing')}
      />
      <Equipment
        formik={formik}
        isOpen={openSections['equipment']}
        onToggle={() => toggleSection('equipment')}
        appData={activeAppData}
      />
      <Details
        formik={formik}
        onEdit={() => onSectionChange('details')}
        isOpen={openSections['details']}
        onToggle={() => toggleSection('details')}
        appData={activeAppData}
      />
      <Processor
        formik={formik}
        onEdit={() => onSectionChange('processor')}
        isOpen={openSections['processor']}
        onToggle={() => toggleSection('processor')}
      />     
      
      {isAuthenticated && otpVerificationTime && (
        <SignAgreement formik={formik} reRender={reRender} />
      )}
    </div>
  );
};

export default ReviewSubmit; 